/** The editable value lists that feed every dropdown in the app. */
import { LISTS } from '../../constants/defaults.js';
import { Section, Chips } from './SettingsBits.jsx';

export default function ListsPane() {
  return (
    <>
      {LISTS.map(l => (
        <Section key={l.k} title={l.n} hint={l.d}>
          <Chips listKey={l.k} />
        </Section>
      ))}
    </>
  );
}
